export default __webpack_public_path__ + "resources/icons/d132-a0f4.webp";